import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { userLogin } from "../actions/index";
// import LoginBtn from "../components/buttons/LoginBtn";

import Btn from "../components/buttons/Btn";
// import LogoutBtn from "../components/buttons/LogoutBtn";
import { gsntvCheckLogin } from "../utils/gsntv";

class AccAccessBtnContainer extends Component {

  onClickHandler() {
    if (this.props.userLoggedIn) {
      this.onLogoutClick();
    } else {
      this.onLoginClick();
    }
  }

  onLoginClick() {
    window.parent && window.parent.gsntvRegisterFromIFrame();
  }

  onLogoutClick() {
    window.parent && window.parent.gsntvLogoutFromIFrame();
  }

  componentDidMount() {
 		//check user login on reload
		// gsntvCheckLogin(this.props.userLogin);
  }

  render() {
    const self = this;
    const {
      userLoggedIn,
      btnRef,
      btnClassName,
      btnLabel,
    } = self.props;

    let label = btnLabel.login;
    let className = btnClassName.login;

    if (userLoggedIn) {
      label = btnLabel.logout;
      className = btnClassName.logout;
    }

    return (
      <Btn label={label} onClick={this.onClickHandler.bind(this)} btnRef={btnRef} btnClassName={className}/>
    );

    // return !userLoggedIn ? (
    //   <LoginBtn onLoginClick={this.onLoginClick.bind(this)} btnRef={btnRef.login} btnClassName={btnClassName.login}/>
    // ) : (
    //   <LogoutBtn onLogoutClick={this.onLogoutClick.bind(this)} btnRef={btnRef.logout} btnClassName={btnClassName.logout}/>
    // );
  }
}

const mapStateToProps = state => ({
  userLoggedIn: state.userLoggedIn,
  isAppIframed: state.isAppIframed,
});

const mapDispatchToProps = dispatch => ({
  userLogin: data => {
    dispatch(userLogin(data));
  }
});

AccAccessBtnContainer.propTypes = {
  btnRef: PropTypes.object,
  btnClassName: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccAccessBtnContainer);


// WEBPACK FOOTER //
// ./src/js/containers/AccAccessBtnContainer.js